import { Component, OnInit } from '@angular/core';
import { PrvNextButtonsComponent } from '../../components/prv-next-buttons/prv-next-buttons.component';
import { CommonModule } from '@angular/common';
import { EopAssistantComponent } from '../../components/eop-assistant/eop-assistant.component';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { FunctionSuggestionComponent } from "./function-suggestion/function-suggestion.component";
import { IntroductionComponent } from '../../components/introduction/introduction.component';
import { UserDataService } from '../../../shared/services/userData.service';
import { FunctionService } from '../../../shared/services/function.service';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { IFunctionGoals } from '../../../shared/models/functionGoal';
import { FunctionDetailsComponent } from '../../components/function-details/function-details.component';
import { NewFunctionComponent } from './new-function/new-function.component';
import { PopupMessageComponent } from '../../components/popup-message/popup-message.component';
import { DeleteConfirmationComponent } from '../../components/delete-confirmation/delete-confirmation.component';
import { FunctionEditComponent } from './function-edit/function-edit.component';
import { ESectionTypes } from '../../../shared/models/eop_types.enum';
import { EopNavigationService } from '../../../shared/services/eopNavigation.service';
import { IUserInfo } from '../../../shared/models/contact';

@Component({
  selector: 'app-functions',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    PrvNextButtonsComponent,
    EopAssistantComponent,
    FunctionSuggestionComponent,
    IntroductionComponent, 
    SpinnerComponent,
    PopupMessageComponent,
    DeleteConfirmationComponent,
    FunctionDetailsComponent,
    NewFunctionComponent,
    FunctionEditComponent
],
  templateUrl: './functions.component.html',
  styleUrl: './functions.component.css'
})
export class FunctionsComponent implements OnInit {
  sectionTypeId = ESectionTypes["Functions - Goals and Objectives"];

  icons = Icons;
  currentUser: IUserInfo | null = null;
  currentBuildingId: string | null = null;
  functionsList: any[] = [];
  selectedFunction: IFunctionGoals | null = null;
  suggestedFunctionName: string = '';
  functionToDelete: number |null = null;
  messageModal: string | null = null;
  popupMessage: string = '';

  loading: boolean = false;
  showAddNewFunction: boolean = false;
  showFunctionDetails: boolean = false;
  showDeleteConfirmation: boolean = false;
  showFunctionEdit: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private functionService: FunctionService,
    public eopNavigationService: EopNavigationService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUser = this.userDataService.getUserData();
    this.loadFunctions();
  }

  loadFunctions(): void {
    if (!this.currentBuildingId) {
      console.error('Current building ID is not set.');
      return;
    }
    this.loading = true;
    this.functionService.getFunctions(this.currentBuildingId).subscribe({
      next: (response) => {
        this.functionsList = response.data ? response.data : [];
        // Sort the list after retrieving functions list.
        if (this.functionsList.length > 0) {
          this.functionsList.sort((a: any, b: any) => a.function_name.localeCompare(b.function_name));
        }
        this.loading = false;
        console.log(response);
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading contacts:', error.message);
      }
    })
  }

  handleOpenModal(modalName: string, selectedItem?: any): void {
    if (modalName === 'new-function') {
      this.showAddNewFunction = true;
    } else if (modalName === 'edit-function') {
      this.showFunctionEdit = true;
    } else if (modalName === 'function-details') {
      this.showFunctionDetails = true;
    } else if (modalName === 'function-suggestion') {
      this.showAddNewFunction = true;
      this.suggestedFunctionName = selectedItem;
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = true;
    }
    this.selectedFunction = selectedItem ? selectedItem : null;
  }

  handleCloseModal(modalName: string): void {
    if (modalName === 'new-function') {
      this.showAddNewFunction = false;
    } else if (modalName === 'edit-function') {
      this.showFunctionEdit = false;
    } else if (modalName === 'function-details') {
      this.showFunctionDetails = false;
    } else if (modalName === 'function-suggestion') {
      this.showAddNewFunction = false;
    } else if (modalName === 'delete-confirmation') {
      this.showDeleteConfirmation = false;
    }
    this.selectedFunction = null;
    this.suggestedFunctionName = '';
  }

  handleSave(message: {type: string, message: string}, actionType: string): void {
    this.handleCloseModal(actionType);
    this.loadFunctions();

    if (message.type === 'success') {
      this.messageModal = 'success';
      this.popupMessage = message.message;
      
    } else if (message.type === 'unsuccess') {
      this.messageModal = 'unsuccess';
      this.popupMessage = message.message;
    } 
  }
  
  handleDelete(item: any): void {
    this.loading = true;
    this.functionService.deleteFunction(item.id).subscribe({
      next: (response) => {
        this.loading = false;
        this.messageModal = "success";
        this.popupMessage = 'This occurred after deleting a function goals and objectives.';
        this.handleCloseModal('delete-confirmation');
        this.loadFunctions();
        console.log('Successfully deleting function: ', response);
      },
      error: (error: any) => {
        this.loading = false;
        this.messageModal = "unsuccess";
        this.popupMessage = error.message;
        console.error('Error deleting function:', error.message);
      }
    })
  }
  
  canSave(): boolean {
    if (!this.currentUser) return false;
    return this.currentUser.can_edit || this.currentUser.can_admin;
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = '';
  }
}
